// authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { loginUserThunk } from './authThunks';
import { APP_SCHEMA_VERSION } from '../../constants/schemaVersion';

const initialState = {
    user: null,
    accessToken: null,
    loading: false,
    error: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: (state) => {
            state.user = null;
            state.accessToken = null;
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUserThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loginUserThunk.fulfilled, (state, action) => {
                state.user = action.payload.user;
                state.accessToken = action.payload.access;
                localStorage.setItem('accessToken', action.payload.access);
                localStorage.setItem('refreshToken', action.payload.refresh);
                localStorage.setItem('schema_version', String(APP_SCHEMA_VERSION));
                state.loading = false;
            })
            .addCase(loginUserThunk.rejected, (state, action) => {
                state.loading = false;
                // Set error message in Redux state for tracking
                state.error = action.payload ? action.payload.message : 'Login failed';
            });
    },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
